import { render } from "./PortalMessageRoom.vue?vue&type=template&id=0d73aaff&scoped=true"
import script from "./PortalMessageRoom.vue?vue&type=script&lang=js"
export * from "./PortalMessageRoom.vue?vue&type=script&lang=js"

import "./PortalMessageRoom.vue?vue&type=style&index=0&id=0d73aaff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d73aaff"]])

export default __exports__